import axios from '../components/axios/axiosconf';
import Swal from 'sweetalert2';

export function usuarioPuedeEnviarSispro() {
    let userdata = {};
    try {
        userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
    } catch (e) {
        userdata = {};
    }
    if (userdata.permissions && Array.isArray(userdata.permissions)) {
        return userdata.permissions.some((p) => p.slug === 'enviarRipsSispro');
    }
    return !!(userdata.up && userdata.up.includes('enviarRipsSispro'));
}

export function ripsYaEnviadoSispro(item) {
    if (!item) return false;
    return item.sispro_enviado === 1
        || item.sispro_enviado === true
        || item.sispro_enviado === '1';
}

export function formatearFechaRadicacionSispro(fecha) {
    if (!fecha) return '';
    const texto = String(fecha);
    if (texto.includes('T')) {
        const [dia, horaRaw] = texto.split('T');
        const hora = horaRaw.replace(/\.\d+.*$/, '').substring(0, 8);
        return `${dia} ${hora}`;
    }
    return texto.substring(0, 19);
}

export function evaluarEnvioSisproPorFactura({ factura_id, factura_estado, factura_tipo_factura, facturaValida }) {
    if (!factura_id) {
        return { ok: true };
    }
    const estadoFactura = facturaValida?.estado_factura ?? factura_estado;
    const esNoElectronica = factura_tipo_factura === 'no_electronica' || estadoFactura === 4 || estadoFactura === 5;
    if (esNoElectronica) {
        return { ok: true };
    }
    if (estadoFactura === 1 || estadoFactura === 2) {
        return { ok: true };
    }
    return {
        ok: false,
        motivo: 'Debe enviar primero la factura electrónica a la DIAN',
    };
}

function tituloErrorSispro(paso) {
    if (paso === 'login_sispro') return 'Error de autenticación SISPRO';
    if (paso === 'xml_faltante') return 'Factura sin XML DIAN';
    return 'Error al enviar a SISPRO';
}

function construirHtmlErrorSispro(mensaje, detalles) {
    const esc = (texto) => String(texto ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    let html = `<p style="text-align:left;margin-bottom:12px;line-height:1.5">${esc(mensaje)}</p>`;

    const validaciones = detalles?.ResultadosValidacion;
    if (Array.isArray(validaciones) && validaciones.length > 0) {
        html += '<div style="text-align:left;max-height:320px;overflow:auto">';
        validaciones.forEach((v) => {
            const clase = String(v.Clase || '').toUpperCase();
            const color = clase === 'RECHAZADO' ? '#dc3545' : '#856404';
            html += `<div style="border-left:3px solid ${color};padding:8px 10px;margin-bottom:8px;background:#f8f9fa;border-radius:4px">`;
            html += `<strong>${esc(v.Codigo)}</strong> <span style="color:${color};font-size:12px">(${esc(clase)})</span><br/>`;
            html += `<span style="font-size:13px">${esc(v.Descripcion)}</span>`;
            if (v.Observaciones) {
                html += `<br/><small style="color:#6c757d">${esc(v.Observaciones)}</small>`;
            }
            if (v.PathFuente) {
                html += `<br/><small style="font-family:ui-monospace,monospace;color:#495057">${esc(v.PathFuente)}</small>`;
            }
            html += '</div>';
        });
        html += '</div>';
    } else if (detalles) {
        html += `<pre style="text-align:left;font-size:11px;max-height:260px;overflow:auto;background:#f4f6f8;padding:10px;border-radius:6px;margin:0;white-space:pre-wrap;word-break:break-word">${esc(JSON.stringify(detalles, null, 2))}</pre>`;
    }

    return html;
}

export async function mostrarErrorSisproSwal({ titulo, mensaje, paso, detalles, status }) {
    let html = construirHtmlErrorSispro(mensaje, detalles);
    if (status) {
        html += `<p class="text-muted small mt-3 mb-0" style="text-align:left">Código HTTP: ${status}${paso ? ` · Paso: ${paso}` : ''}</p>`;
    }

    await Swal.fire({
        icon: 'error',
        title: titulo || tituloErrorSispro(paso),
        html,
        width: '42rem',
        confirmButtonText: 'Cerrar',
    });
}

/**
 * Confirma y envía un RIPS a SISPRO.
 * @returns {{ ok: boolean, reason?: string, data?: object }}
 */
export async function enviarRipsASispro(ripsItem, options = {}) {
    const { omitirConfirmacion = false } = options;
    const rips_id = ripsItem.id;

    if (!usuarioPuedeEnviarSispro()) {
        await Swal.fire({
            icon: 'warning',
            title: 'Sin permiso',
            text: 'No tiene permiso para enviar a SISPRO.',
            confirmButtonText: 'Aceptar',
        });
        return { ok: false, reason: 'permiso' };
    }

    if (ripsYaEnviadoSispro(ripsItem)) {
        await Swal.fire({
            icon: 'info',
            title: 'Ya enviado',
            text: 'Este RIPS ya fue enviado a SISPRO.',
            confirmButtonText: 'Aceptar',
        });
        return { ok: false, reason: 'enviado' };
    }

    const confirmacion = omitirConfirmacion
        ? { isConfirmed: true }
        : await Swal.fire({
            title: '¿Enviar RIPS a SISPRO?',
            text: 'Se enviará el RIPS al sistema SISPRO del Ministerio de Salud',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#323a45',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Sí, enviar',
            cancelButtonText: 'Cancelar',
        });

    if (!confirmacion.isConfirmed) {
        return { ok: false, reason: 'cancelado' };
    }

    if (ripsItem.factura_id) {
        try {
            const validacion = await axios.post('/rips-sispro/validar-factura', {
                factura_id: ripsItem.factura_id,
            });
            const evalFactura = evaluarEnvioSisproPorFactura({
                factura_id: ripsItem.factura_id,
                factura_estado: ripsItem.factura_estado,
                factura_tipo_factura: ripsItem.factura_tipo_factura,
                facturaValida: validacion.data,
            });
            if (!evalFactura.ok) {
                await Swal.fire({
                    icon: 'warning',
                    title: 'Factura pendiente',
                    text: evalFactura.motivo,
                    confirmButtonText: 'Aceptar',
                });
                return { ok: false, reason: 'factura' };
            }
        } catch (error) {
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo validar el estado de la factura',
                confirmButtonText: 'Aceptar',
            });
            return { ok: false, reason: 'validacion' };
        }
    }

    try {
        const verif = await axios.post('/rips-sispro/datos-configuracion', { rips_id });
        if (!verif.data?.configurado) {
            return { ok: false, reason: 'config' };
        }
    } catch (error) {
        if (error.response?.data?.requiere_configuracion) {
            return { ok: false, reason: 'config' };
        }
        await mostrarErrorSisproSwal({
            titulo: 'Error al verificar SISPRO',
            mensaje: error.response?.data?.message || 'No se pudo verificar la configuración SISPRO',
            paso: null,
            detalles: error.response?.data || null,
            status: error.response?.status,
        });
        return { ok: false, reason: 'config_error' };
    }

    try {
        const response = await axios.post('/rips-sispro/enviar', { rips_id });
        await Swal.fire({
            icon: 'success',
            title: '¡RIPS enviado!',
            html: `
                <p>El RIPS fue enviado exitosamente a SISPRO</p>
                <hr>
                <p><strong>CUV:</strong> ${response.data.cuv || ''}</p>
                <p><strong>Fecha de radicación:</strong> ${formatearFechaRadicacionSispro(response.data.fecha_radicacion)}</p>
            `,
            confirmButtonText: 'Aceptar',
        });
        return { ok: true, data: response.data };
    } catch (error) {
        const data = error.response?.data || {};
        const paso = data.paso || null;
        let errorMessage = data.message || 'Error al enviar RIPS a SISPRO';
        if (paso === 'login_sispro') {
            errorMessage = data.message || 'El login en SISPRO falló. Verifique contraseña, NIT y tipo de usuario del profesional configurado.';
        } else if (paso === 'xml_faltante') {
            errorMessage = data.message || 'Falta el XML de la factura en la DIAN. Envíe la factura a la DIAN antes de radicar el RIPS.';
        } else if (paso === 'envio_rips') {
            errorMessage = data.message || 'SISPRO rechazó el paquete RIPS. Revise los detalles de validación.';
        }
        if (data.requiere_configuracion) {
            return { ok: false, reason: 'config' };
        }
        await mostrarErrorSisproSwal({
            titulo: tituloErrorSispro(paso),
            mensaje: errorMessage,
            paso,
            detalles: data.detalles || data || null,
            status: error.response?.status,
        });
        return { ok: false, reason: 'envio', detalles: data.detalles || data || null };
    }
}
